import React from 'react'
import { connect } from 'react-redux'
import * as styled from 'StyledVirtuals'

const Virtuals = ({ isLogged }) => {
  const src = process.env.RGS_URL

  return (
    <styled.Iframe id="virtuals-iframe" key={isLogged} src={src} />
  )
}

const mapStateToProps = ({ Auth: { isLogged } }) => ({ isLogged })

export default connect(mapStateToProps)(Virtuals)
